import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import CustomDateModal from '../../CustomModal/CustomDateModal';


const ReceiptedMaster = (props) => {



    //----------- REDUCE TOOLKIT -------
    const vendorState = useSelector((state) => state.vendorState);
    const branchState = useSelector((state) => state.branchState);
    const { user } = useSelector((state) => state.authState);

    const [challanTable, setChallanTable] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

    const [searchKey, setSearchkey] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showDateModel, setShowDateModel] = useState(false);
    const [allDateSelected, setAllDateSelected] = useState(true);
    const [totalPage, setTotalPage] = useState(); // Current page for pagination


    const getChallanData = async (flag, search, page = 1, limit = 10, venderMstId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            // Build query params conditionally
            let queryParams = `flag=${flag ? flag : props.irFlag}&pageNo=${page}&pageSize=${limit}`;

            if (search) queryParams += `&searchKey=${encodeURIComponent(search ? search : searchKey)}`;
            if (startDate) queryParams += `&startDate=${encodeURIComponent(startDate)}`;
            if (endDate) queryParams += `&endDate=${encodeURIComponent(endDate)}`;
            // if (selectedVendorId) queryParams += `&venderMasterId=${encodeURIComponent(selectedVendorId)}`;
            // if (selectedBranchId) queryParams += `&branchMasterId=${encodeURIComponent(selectedBranchId)}`;
            const vendorIdToUse = venderMstId || selectedVendorId;
            if (vendorIdToUse) {
                queryParams += `&venderMasterId=${encodeURIComponent(vendorIdToUse)}`;
            }

            // ✅ Only include branchMasterId if venderMstId is NOT passed directly
            if (selectedBranchId && !venderMstId) {
                queryParams += `&branchMasterId=${encodeURIComponent(selectedBranchId)}`;
            }


            // const response = await apiService.get(`/api/IssueReceipt/allchallan?flag=${flag}`, config)
            const response = await apiService.get(`/api/IssueReceipt/allchallan?${queryParams}`, config);
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setChallanTable(response.issueReceiptMasterDetailData)
                setTotalPage(response.totalPages)

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };


    // useEffect(() => {
    //     getChallanData(props?.irFlag, "");
    // }, [!challanTable, props?.irFlag]);

    // useEffect(() => {
    //     getChallanData(props?.irFlag);
    // }, [searchKey, fromDate, toDate]);

    const onHandleChallan = () => {

        //rececive challan
        if (props?.irFlag == "RC") {
            navigate("/add_challan_receive")
        }

        // navigate("/add_challan_receive")

        //sale return challan
        if (props?.irFlag == "SRC") {
            navigate("/add_challan_sale_return")
        }

        // purchsse return challan 
        if (props?.irFlag == "PRC") {
            navigate("/add_challan_purchase_return")
        }
    }

    const onHandleDeleteChallan = async (challanId) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/IssueReceipt/delete?challanId=${challanId}`, config)
                if (response.response && response.response.data.errors) {
                    toast.success(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getChallanData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    }

    const onHandleEditChallan = (challanId) => {
        let findArrayData = challanTable.find(e => e.id === challanId);

        //receive challan
        if (props?.irFlag == "RC") {
            navigate('/add_challan_receive', { state: { challanId: findArrayData.id, partyId: findArrayData.pcode } });
        }

        //sale return challan
        if (props?.irFlag == "SRC") {
            navigate("/add_challan_sale_return", { state: { challanId: findArrayData.id, partyId: findArrayData.pcode } })
        }

        // purchsse return challan 
        if (props?.irFlag == "PRC") {
            navigate("/add_challan_purchase_return", { state: { challanId: findArrayData.id, partyId: findArrayData.pcode } })
        }

    }



    const onHandleSearchKey = (e) => {
        let search = e.target.value;
        setSearchkey(search);
        getChallanData(props?.irFlag, search)
    }
    const handleApply = () => {
        setShowDateModel(true);
    }


    const handlePageClick = (data) => {
        getChallanData(props?.irFlag, "", data.selected + 1, 10)
    };

    // =======================  VENDER & BRANCH =================

    const [selectedVendorId, setSelectedVendorId] = useState("");
    const [selectedBranchId, setSelectedBranchId] = useState("");

    // Handle vendor selection change
    const selectVendorFilter = (e) => {

        let value = e.target.value
        if (!value) {
            setSelectedVendorId(value);
            setSelectedBranchId("");
        } else {
            setSelectedVendorId(value);
            setSelectedBranchId("");
            getChallanData(props?.irFlag, "", 1, 10, value);

            // getBranchMasterData(1, 10, "", value)
        }
    };


    // Handle branch selection change
    const selectbranchFilter = (e) => {
        setSelectedBranchId(e.target.value);
    };

    // useEffect(() => {
    //     getChallanData(props?.irFlag, "", 1, 10);
    // }, [selectedVendorId, selectedBranchId])

    useEffect(() => {

        if (user.user_profile != "superadmin" && selectedVendorId && selectedBranchId) {
            getChallanData(props?.irFlag, "", 1, 10);
        } else if (user.user_profile == "superadmin") {
            getChallanData(props?.irFlag, "", 1, 10);
        }

        if (vendorState.vendors.length == 1) {
            setSelectedVendorId(vendorState.vendors[0].id);
        }

        if (branchState.branches.length == 1) {
            setSelectedBranchId(branchState.branches[0].id);
        }
    }, [selectedVendorId, selectedBranchId])




    return (
        <>
            <Col lg="12">
                {/* <Row> */}

                {/* </Row> */}

                <Card className='bg-white pd-10 card-box mb-30'>

                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 sticky-top">

                        <Row className="align-items-center g-2 mb-2">
                            <Col xs={12} className="d-flex justify-content-between align-items-center">
                                {/* Title aligned left */}
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-card-text mr-2"></i>
                                    {props?.title}
                                </div>
                                <div className="d-flex justify-content-end mb-2">
                                    <Button color="success" onClick={onHandleChallan} className="d-flex align-items-center">
                                        <i className="bi bi-plus-circle mr-2"></i>
                                        New
                                    </Button>
                                </div>

                            </Col>
                        </Row>

                        <Row style={{ display: "flex", justifyContent: "start" }}>


                            {/* Search and Filter in same line, centered */}
                            <Col xl={12} className="d-flex justify-content-center justify-content-md-end align-items-center gap-2">

                                <Input

                                    id="search"
                                    name="search"
                                    placeholder="Search..."
                                    type="text"
                                    // style={{ minWidth: '250px' }}
                                    onChange={(e) => onHandleSearchKey(e)}
                                />
                                <Button color="info" onClick={handleApply}>
                                    <i className="bi bi-funnel mr-1"></i>
                                    <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Filter</p>

                                </Button>
                            </Col>

                        </Row>


                        <Row style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                            {/* Vendor Filter */}
                            {(vendorState?.vendors.length === 0 || vendorState?.vendors.length > 1) && (
                                <Col xl={3} md={4} sm={6} style={{ marginBottom: "15px" }}>
                                    <FormGroup>
                                        <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Vendor</label>
                                        <Input
                                            style={{
                                                border: "1px solid #ced4da",
                                                borderRadius: "4px",
                                                padding: "6px 12px",
                                            }}
                                            type="select" className="custom-select"
                                            name="selectedVendorId"
                                            value={selectedVendorId}
                                            onChange={selectVendorFilter}
                                        >
                                            <option value="">-- Select Vendor --</option>
                                            {vendorState?.vendors.map((data) => (
                                                <option key={data.id} value={data.id}>
                                                    {data.vender_name}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            )}

                            {/* Branch Filter */}
                            {(branchState?.branches?.length === 0 ||
                                branchState?.branches?.length > 1) && (
                                    <Col xl={3} md={4} sm={6} style={{ marginBottom: "15px" }}>
                                        <FormGroup>
                                            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Branch</label>
                                            <Input
                                                style={{
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    padding: "6px 12px",
                                                }}
                                                type="select" className="custom-select"
                                                name="selectedBranchId"
                                                value={selectedBranchId}
                                                onChange={selectbranchFilter}
                                                disabled={!selectedVendorId}
                                            >
                                                <option value="">-- Select Branch --</option>
                                                {branchState?.branches
                                                    ?.filter((data) =>
                                                        selectedVendorId
                                                            ? String(data.vender_master_id) === String(selectedVendorId)
                                                            : true // Show all branches if no vendor is selected
                                                    )
                                                    .map((data) => (
                                                        <option key={data.id} value={data.id}>
                                                            {data.branch_name}
                                                        </option>
                                                    ))}

                                            </Input>
                                        </FormGroup>
                                    </Col>
                                )}
                        </Row>
                    </CardTitle>

                    <CardBody className="">
                        <Table striped>
                            <thead>
                                <tr>
                                    {/*  <th>S. no.</th> */}
                                    <th>Bill No.</th>
                                    {(user.user_profile == "superadmin" || branchState.length) && <th>Branch/Vendor Name</th>}

                                    <th>Bill Date</th>
                                    <th>Party  Name</th>
                                    <th>Qty</th>

                                    <th>Amt</th>
                                    {/* <th>Permit No</th>
                                    <th>Vehicle No</th> */}
                                    {/* <th>Edit</th> */}
                                    {/* <th>Delete</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {challanTable.length > 0 ? (
                                    challanTable.map((item, index) => (
                                        <tr key={index}>
                                            <th scope="row">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <span className="ms-2 fw-bold">{item.manual_billno}</span>
                                                    <Button
                                                        color="warning"
                                                        size="sm"
                                                        className="mt-1 ms-2"
                                                        onClick={() => onHandleEditChallan(item.id)}
                                                    >
                                                        <i className="bi bi-pencil mr-1"></i> Edit
                                                    </Button>
                                                </div>
                                            </th>

                                            {(user.user_profile === "superadmin" || branchState.length > 0) && (
                                                <td>
                                                    <strong>{item.branch_name}</strong>
                                                    <br />
                                                    {item.vender_name}
                                                </td>
                                            )}

                                            <td>{item.bill_date?.split("T")[0]}</td>
                                            <td>
                                                {item.pname}{" "}
                                                <span className="text-muted">({item.agr_code_old})</span>
                                            </td>
                                            <td>{item.tot_qty}</td>
                                            <td>₹{item.final_amount}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6} className="text-center text-muted py-3">
                                            No Data Found!
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </Table>
                        <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            pageCount={totalPage} // still 4000
                            marginPagesDisplayed={1} // 1 page at start & end
                            pageRangeDisplayed={2}  // visible range around selected page
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}

                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            nextClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />
                    </CardBody>

                </Card>
            </Col>

            {/* Data Filter */}
            <CustomDateModal

                filterFlag="sale_report"

                showDateModel={showDateModel}
                setShowDateModel={setShowDateModel}

                allDateSelected={allDateSelected}
                setAllDateSelected={setAllDateSelected}

                startDate={startDate}
                setStartDate={setStartDate}

                endDate={endDate}
                setEndDate={setEndDate}

                // handleCloseModel={handleCloseModel}
                // handleFilterDate={handleFilterDate}
                getChallanData={getChallanData}
            />

        </>
    )
}



export default ReceiptedMaster